export const FREQUENCIES = [125, 250, 500, 1000, 2000, 4000, 8000];
export const DB_MIN = -10;
export const DB_MAX = 120;
export const DB_STEP = 5;
export const DB_LEVELS = Array.from(
  { length: (DB_MAX - DB_MIN) / DB_STEP + 1 },
  (_, i) => DB_MIN + i * DB_STEP
);

export type AudiometerCursor = { freqIndex: number; dbIndex: number };

// AC = air conduction (headphones), BC = bone conduction — BC is only measured between 250 Hz and 4000 Hz.
export type MeasurementMode = "AC" | "BC";
export const BC_FREQ_MIN_INDEX = FREQUENCIES.indexOf(250);
export const BC_FREQ_MAX_INDEX = FREQUENCIES.indexOf(4000);
